import { render } from "./PageError.vue?vue&type=template&id=5b1867e6&ts=true"
import script from "./PageError.vue?vue&type=script&lang=ts"
export * from "./PageError.vue?vue&type=script&lang=ts"

import "./PageError.vue?vue&type=style&index=0&id=5b1867e6&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__